import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Contact1 from './../../assets/images/homepage/contact1.jpg'
import Contact2 from './../../assets/images/homepage/contact2.jpg'
import MoreIcon from './../../assets/images/icn-go@3x-black.png'
import MoreIconWhite from './../../assets/images/icn-go@3x-white.png'
import { useHistory } from 'react-router-dom'
import { injectIntl } from 'react-intl'
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: "160px",
        background: "#001229",
        [theme.breakpoints.down('sm')]: {
            marginTop: "20px",
        },
        "& .contact-block": {
            transform: "translateY(-100px)",
            maxWidth: "1280px",
            margin: "0px auto",
            [theme.breakpoints.down('sm')]: {
                transform: "translateY(0px)",
            }
        },
        "& .title": { padding: "0px 24px" },
        "& .block": {
            cursor: "pointer",
            overflow: "hidden",
            position: "relative",
            height: "490px",
            backgroundSize: "cover",
            backgroundPosition: "center",
            color: "#ffffff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "&:hover": {
                "&:before": {
                    content: "''",
                    display: "block",
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    top: "0px",
                    left: "0px",
                    background: "rgba(218,184,115,0.6)",
                },
                "& .title": {
                    display: "none"
                },
                "& .more-details": {
                    display: "none"
                },
            },
            [theme.breakpoints.down('sm')]: {
                height: "290px"
            }
        },
        "& .left-block": {
            backgroundImage: `url(${Contact1})`,
            "&:hover .more-details-hover": {
                animationDuration: "0.6s",
                animationName: "$mask",
                animationFillMode: "forwards",
                [theme.breakpoints.down('sm')]: {
                    animationName: "$mask_2",
                },
                [theme.breakpoints.down('xs')]: {
                    animationName: "$mask_3",
                }
            }
        },
        "& .right-block": {
            backgroundImage: `url(${Contact2})`,
            "&:hover .more-details-hover": {
                animationDuration: "0.6s",
                animationName: "$mask2",
                animationFillMode: "forwards",
                [theme.breakpoints.down('sm')]: {
                    animationName: "$mask2_2",
                },
                [theme.breakpoints.down('xs')]: {
                    animationName: "$mask2_3",
                }
            }
        },
        "& .more-details": {
            height: "46px",
            background: "#dab873",
            padding: "12px 24px 12px 30px",
            color: "#001733",
            position: "absolute",
            right: "0px",
            bottom: "0px",
            "&:before": {
                position: "absolute",
                display: "block",
                top: "0px",
                left: "-43px",
                content: "''",
                width: "0",
                height: "0",
                borderStyle: "solid",
                borderWidth: "0 0 46px 43px",
                borderColor: "transparent transparent #dab873 transparent"
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: "14px",
                padding: "6px 18px 6px 20px",
                height: "32px"
            }
        },
        "& .more-details-hover": {
            overflow: "hidden",
            opacity: "0",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            whiteSpace: "nowrap"
        },
        "& .more-details-icon": {
            display: "inline-block",
            margin: "0px 0px 6px 10px",
            width: "32px",
            height: "4px",
            backgroundImage: `url(${MoreIcon})`,
            backgroundSize: "cover",
            [theme.breakpoints.down('sm')]: {
                margin: "0px 0px 5px 8px",
                width: "25px",
                height: "3px",
            }
        },
        "& .more-details-icon-hover": {
            display: "inline-block",
            margin: "0px 0px 6px 10px",
            width: "40px",
            height: "4px",
            backgroundImage: `url(${MoreIconWhite})`,
            backgroundSize: "cover"
        }
    },
    "@keyframes mask": {
        "0%": {
            opacity: "0",
            width: "0px"
        },
        "100%": {
            opacity: "1",
            width: "274px",
        }
    },
    "@keyframes mask_2": {
        "0%": {
            opacity: "0",
            width: "0px"
        },
        "100%": {
            opacity: "1",
            width: "242px",
        }
    },
    "@keyframes mask_3": {
        "0%": {
            opacity: "0",
            width: "0px"
        },
        "100%": {
            opacity: "1",
            width: "210px",
        }
    },
    "@keyframes mask2": {
        "0%": {
            opacity: "0",
            width: "0px"
        },
        "100%": {
            opacity: "1",
            width: "162px"
        }
    },
    "@keyframes mask2_2": {
        "0%": {
            opacity: "0",
            width: "0px"
        },
        "100%": {
            opacity: "1",
            width: "146px"
        }
    },
    "@keyframes mask2_3": {
        "0%": {
            opacity: "0",
            width: "0px"
        },
        "100%": {
            opacity: "1",
            width: "130px"
        }
    },
}))
const ExtraFooter = (props: any) => {
    const { intl } = props
    const classes = useStyles()
    const history = useHistory()
    return (
        <div className={classes.root}>
            <Grid container className="contact-block">
                <Grid item xs={12} sm={12} md={6} lg={6} className="block left-block" onClick={() => history.push(`/contact`)}>
                    <Typography className="title" variant="h3">{intl.formatMessage({ id: "extraFooter.1.title" })}</Typography>
                    <Typography className="more-details" variant="h6">{intl.formatMessage({ id: "extraFooter.1.button" })}
                        <div className="more-details-icon" />
                    </Typography>
                    <Typography className="more-details-hover" variant="h3">{intl.formatMessage({ id: "extraFooter.1.button" })}
                        <div className="more-details-icon-hover" />
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} className="block right-block" onClick={() => history.push(`/news?page=1&type=ALL`)}>
                    <Typography className="title" variant="h3">{intl.formatMessage({ id: "extraFooter.2.title" })}</Typography>
                    <Typography className="more-details" variant="h6">{intl.formatMessage({ id: "extraFooter.2.button" })}
                        <div className="more-details-icon" />
                    </Typography>
                    <Typography className="more-details-hover" variant="h3">{intl.formatMessage({ id: "extraFooter.2.button" })}
                        <div className="more-details-icon-hover" />
                    </Typography>
                </Grid>
            </Grid>
        </div>
    )
}
export default injectIntl(ExtraFooter)